// extracted by mini-css-extract-plugin
module.exports = {"boardCardGrid":"BoardCard_boardCardGrid__2PUQ4","boardCard":"BoardCard_boardCard__3eIs1","viewButton":"BoardCard_viewButton__2wkuI"};